import React from 'react';
import './App.css';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CircularProgress from '@mui/material/CircularProgress';
import upiqr from 'upiqr';
import Razorpay from './Razorpay.js';
import SmartCollect from './SmartCollect.js';
import {ListSubheader} from "@mui/material";
import {PAYMENT_LABEL_MAPPING} from "./App";

const PAYMENT_GATEWAY_MAPPING = {
    'credit-card': 'razorpay',
    'debit-card': 'razorpay',
    'wallet': 'razorpay',
    'netbanking': 'razorpay',
    // 'upi': 'smart-collect',
    'bank-transfer': 'smart-collect',
    // 'cash-deposit': 'smart-collect'
}

export default class PaymentArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentMethod: '',
            orderId: Date.now().valueOf()
        }
        this.handleChangeInPaymentMethod = this.handleChangeInPaymentMethod.bind(this);
        this.setupGateway = this.setupGateway.bind(this);
        this.setupRazorpay = this.setupRazorpay.bind(this);
        this.setupSmartCollect = this.setupSmartCollect.bind(this);
    }

    handleChangeInPaymentMethod(e) {
        let paymentGateway = PAYMENT_GATEWAY_MAPPING[e.target.value];
        let convenienceFee = Math.ceil(parseInt(this.props.amount) * 2.5 / 100);

        if (paymentGateway === 'razorpay') {
            convenienceFee = Math.ceil(parseInt(this.props.amount) * 2.5 / 100);
        } else if (paymentGateway === 'smart-collect') {
            // convenienceFee = Math.min(parseInt(this.props.amount) * 1.2 / 100, 12);
            convenienceFee = 0
        }
        if (this.state[paymentGateway]) {
            this.setState({
                ...this.state,
                paymentMethod: e.target.value,
                paymentGateway: paymentGateway,
                paymentGatewayInfo: e.target.value,
                convenienceFee: convenienceFee,
                totalAmount: parseInt(this.props.amount) + convenienceFee
            })
        } else {
            this.setState({
                ...this.state,
                paymentMethod: e.target.value,
                paymentGateway: paymentGateway,
                paymentGatewayInfo: e.target.value,
                convenienceFee: convenienceFee,
                totalAmount: parseInt(this.props.amount) + convenienceFee
            })
            this.setupGateway(paymentGateway, parseInt(this.props.amount) + convenienceFee)
                .then(gatewayDetails => {
                    this.setState({
                        ...this.state,
                        paymentMethod: e.target.value,
                        paymentGateway: paymentGateway,
                        [paymentGateway]: gatewayDetails,
                        paymentGatewayInfo: e.target.value
                    })
                });
        }
    }

    setupGateway(paymentGateway, totalAmount) {
        if (paymentGateway === 'razorpay') {
            return this.setupRazorpay(totalAmount);
        } else if (paymentGateway === 'smart-collect') {
            return this.setupSmartCollect(totalAmount);
        }
    }

    setupRazorpay(totalAmount) {
        return fetch('https://i97sgo2lwk.execute-api.ap-south-1.amazonaws.com/create-razorpay-order?orderId=' + this.state.orderId + '&amount=' + totalAmount + '&paymentType=' + this.props.paymentType)
            .then(result => result.text())
            .then(result => JSON.parse(result));
    }

    setupSmartCollect(totalAmount) {
        return fetch('https://i97sgo2lwk.execute-api.ap-south-1.amazonaws.com/create-virtual-account?orderId=' + this.state.orderId + '&amount=' + totalAmount + '&paymentType=' + this.props.paymentType + '&paymentPurpose=' + PAYMENT_LABEL_MAPPING[this.props.paymentInfo.paymentType]['label'] + ' | ' + this.props.paymentInfo.purposeDescriptor + ' - ' + this.props.paymentInfo.purpose + '&name=' + this.props.paymentInfo.name + '&email=' + this.props.paymentInfo.email + '&phone=' + this.props.paymentInfo.phone + '&clubNum=' + this.props.paymentInfo.clubNum + '&consent=' + this.props.paymentInfo.consent + '&productList=' + this.props.paymentInfo.notes)
            .then(result => result.text())
            .then(result => JSON.parse(result))
            .then(result => {

                let bank = result.receivers.filter(receiver => receiver.entity === 'bank_account')[0];
                let upi = result.receivers.filter(receiver => receiver.entity === 'vpa')[0];

                return {
                    bank: bank
                }

                // return upiqr({
                //     payeeVPA: upi.address,
                //     payeeName: "Tangent India",
                //     transactionNote: 'Payment for Order# ' + this.state.orderId,
                //     amount: this.state.totalAmount,
                //     currency: 'INR'
                // })
                //     .then((upiQr) => {
                //         return {
                //             bank: bank,
                //             upi: upi,
                //             upiQr: upiQr.qr,
                //             upiIntent: upiQr.intent
                //         };
                //     })
            });
    }

    render() {
        if (!this.props.amount) {
            return <div style={{display: 'flex', justifyContent: 'center'}} className='mid-margin'><CircularProgress/>
            </div>
        }

        let paymentSpecificArea = <div/>;
        if (this.state.paymentGateway === 'razorpay') {
            paymentSpecificArea = <Razorpay {...this.props} orderId={this.state.orderId} amount={this.state.totalAmount}
                                            convenienceFee={this.state.convenienceFee}
                                            razorpay={this.state.razorpay} paymentType={this.props.paymentType}/>
        } else if (this.state.paymentGateway === 'smart-collect') {
            paymentSpecificArea =
                <SmartCollect {...this.props} {...this.state['smart-collect']} type={this.state.paymentGatewayInfo} {...this.state} />
        }
        return (
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{minHeight: '100vh'}}
            >
                <Paper elevation={10} className="background-paper">
                    <div style={{textAlign: 'center'}}>
                        <img src='https://assets.tangentindia.org/assets/national_logo.png' style={{width: '50%'}} alt='Tangent India Logo'/>
                    </div>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <ReceiptIcon/>
                            </ListItemIcon>
                            <ListItemText primary={"Order Number: " + this.state.orderId}/>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <PaymentIcon/>
                            </ListItemIcon>
                            <ListItemText primary={"Payment Amount: ₹" + (this.props.amount)}/>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <PaymentIcon/>
                            </ListItemIcon>
                            <ListItemText
                                primary={"Convenience Fee: " + (this.state.convenienceFee === 0 ? '₹0' : (this.state.convenienceFee ? ('₹' + this.state.convenienceFee) : 'To Be Calculated'))}/>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <PaymentIcon/>
                            </ListItemIcon>
                            <ListItemText primary={"Total Amount: " + (this.state.totalAmount ? ('₹' + this.state.totalAmount) : 'To Be Calculated')}/>
                        </ListItem>
                    </List>
                    <Divider/>
                    <FormControl fullWidth>
                        <InputLabel id="payment-mode-select">Mode of Payment</InputLabel>
                        <Select
                            labelId="payment-mode-select"
                            id="payment-mode-select"
                            value={this.state.paymentMethod}
                            label="Payment Method"
                            onChange={this.handleChangeInPaymentMethod}
                        >
                            <ListSubheader>Recommended (No Convenience Fee)</ListSubheader>
                            {/*<MenuItem value='upi'>UPI</MenuItem>*/}
                            <MenuItem value='bank-transfer'>NEFT/IMPS/Bank Transfer</MenuItem>
                            {/*<MenuItem value='cash-deposit'>Cash Deposit</MenuItem>*/}
                            <ListSubheader>Convenience Fee: ₹{Math.ceil(parseInt(this.props.amount) * 2.5 / 100)}</ListSubheader>
                            <MenuItem value='credit-card'>Credit Card</MenuItem>
                            <MenuItem value='debit-card'>Debit Card</MenuItem>
                            <MenuItem value='wallet'>Wallet</MenuItem>
                            <MenuItem value='netbanking'>Net Banking</MenuItem>
                        </Select>
                    </FormControl>
                    <div>
                        {paymentSpecificArea}
                    </div>
                </Paper>
            </Grid>
        );
    }
}